<template>
  <div class="modal">
    <!-- Content -->
    <div class="modal-content">
      <!-- Close -->
      <!-- <div class="row">
        
      </div>-->
      <!-- Content -->
      <v-layout row="wrap" align-center px-4 py-3 v-if="false">
        <v-flex
          shrink
          class="title-text"
          style="color:#6CC8A0;font-size:18px;"
          v-if="true"
          >{{ $t(flag) }}</v-flex
        >
        <v-spacer />
      </v-layout>
      <v-layout row="wrap" align-center px-4 py-3>
        <v-flex
          shrink
          class="title-text"
          style="color:#6CC8A0;font-size:18px;"
          >{{ $t(title) }}</v-flex
        >
        <v-spacer />
        <v-flex shrink>
          <img
            src="@/assets/imgs/close.jpg"
            style="width: 16px; height:16px;cursor: pointer"
            @click="close"
          />
        </v-flex>
      </v-layout>
      <v-layout row="wrap" align-center px-4 py-3>
        <v-flex mt-1 shrink class="text" style="color:#6E6E6E;">{{
          $t(message)
        }}</v-flex>
      </v-layout>
      <v-layout row="wrap" align-center py-3>
        <v-flex md6 px-3>
          <v-btn
            block
            class="ma-2"
            depressed
            @click="close"
            color="#707070;"
            text
            style="color: #707070;text-transform: none"
            >{{ $t("cancel") }}</v-btn
          >
        </v-flex>
        <v-flex md6 px-3>
          <v-btn
            block
            depressed
            text
            @click="Delete"
            style="color: #6CC8A0; text-transform: none"
            >{{ $t("delete") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="deleteModal" persistent max-width="500">
      <v-card style="padding: 10px 5px 10px 0">
        <v-card-text>
          <v-layout row="wrap">
            <v-spacer />
            <v-flex
              shrink
              style="cursor: pointer"
              @click="(deleteModal = false), reload()"
            >
              <v-img
                src="@/assets/close.svg"
                aspect-ratio="1.7"
                width="13"
                height="13"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text style="padding: 0 27px 0">
          <v-layout align-center>
            <v-flex shrink mr-5>
              <v-img
                :src="require(`@/assets/imgs/announcment.png`)"
                aspect-ratio="1.7"
                width="60"
                height="60"
              ></v-img>
            </v-flex>
            <v-flex pt-3>
              <p class="alert-text">{{ current }} deleted successfully.</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#6CC8A0"
            style="color: #fff"
            @click="(deleteModal = false), reload()"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "../views/Mixins/GlobalMixin";
import axios from "axios";
import enurl from "@/api/environment";
export default {
  name: "ModalDel",
  mixins: [GlobalMixin],
  data() {
    return {
      deleteModal: false,
      current: "hola",
      url: enurl.apiUrl
    };
  },
  props: {
    title: String,
    message: String,
    tempID: String, //company id to delete...
    empIdToDelete: Number, //employee id to delete...
    new_ID: String,
    flag: String
  },
  methods: {
    reload() {
      window.location.reload();
    },
    close() {
      this.$emit("close");
    },
    Delete() {
      var self = this;
      if (self.flag == "removecompany") {
        self.current = "company";
        axios
          .post(`${self.url}Company/DeleteCompany?id=${self.tempID}`)
          .then(function(response) {
            self.deleteModal = true;
            if (response.data.status == 0) {
              // self.add_log(
              //   "-", //phonemodal
              //   "Delete Company", //description
              //   "High", //logType
              //   "Delete", //methodName
              //   "", //exception
              //   "", //logTrace
              //   34 //correctionID
              // );
            }
          })
          .catch(function(error) {
            // self.add_log(
            //   "-", //phonemodal
            //   "Cannot Delete Company", //description
            //   "Critical", //logType
            //   "Delete", //methodName
            //   error.message, //exception
            //   JSON.stringify(error), //logTrace
            //   34 //correctionID
            // );
          });
      } else if (self.flag == "removeemployee") {
        self.current = "employee";
        axios
          .post(
            `${self.url}EmployeeCom/DeleteEmployeeCPById?id=` +
              self.empIdToDelete
          )
          .then(function(response) {
            self.deleteModal = true;
            if (response.data.status == 0) {
              // self.add_log(
              //   "-", //phonemodal
              //   "Delete Employee", //description
              //   "High", //logType
              //   "Delete", //methodName
              //   "", //exception
              //   "", //logTrace
              //   34 //correctionID
              // );
            }
          })
          .catch(function(error) {
            // self.add_log(
            //   "-", //phonemodal
            //   "Cannot Delete Company", //description
            //   "Critical", //logType
            //   "Delete", //methodName
            //   error.message, //exception
            //   JSON.stringify(error), //logTrace
            //   34 //correctionID
            // );
          });
      } else if (self.title == "removeannouncement") {
        self.current = "announcment";
        axios
          .post(`${self.url}News/DeleteNews?id=${self.new_ID}`)
          .then(function(response) {
            self.deleteModal = true;
            // self.add_log(
            //   "-", //phonemodal
            //   "Delete Announcement", //description
            //   "High", //logType
            //   "Delete", //methodName
            //   "", //exception
            //   "", //logTrace
            //   34 //correctionID
            // );
          })
          .catch(function(error) {
            // self.add_log(
            //   "-", //phonemodal
            //   "Cannot Delete Announcement", //description
            //   "Critical", //logType
            //   "Delete", //methodName
            //   error.message, //exception
            //   JSON.stringify(error), //logTrace
            //   34 //correctionID
            // );
          });
      }
    }
  }
};
</script>

<style scoped>
.close-img {
  background-color: #eb2127;
  border-radius: 20px;
  border: 3px solid #eb2127;
  width: 30px;
  height: 30px;
  margin-top: 5px;
}
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  background-color: #fefefe;
  margin: 5% auto;
  padding: 30px 40px 15px 40px;
  border: 1px solid #888;
  max-width: 490px;
  border-radius: 25px;
}
.modal-content .close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.modal-content .close:hover,
.modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-footer button {
  outline: none;
}
.cross {
  margin-right: 20px;
}
@media only screen and (max-width: 600px) {
  .modal-content {
    max-width: 390px;
    padding: 11px 20px 11px 16px;
  }
}
@media only screen and (max-width: 400px) {
  .modal-content {
    max-width: 310px;
    padding: 11px 20px 11px 16px;
  }
  .cross {
    margin-right: 3px;
  }
}
</style>
